// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"34":"aae5770e","79":"1c208188","119":"b6344da3","371":"a1cb934c","786":"e904c10f","915":"cb00e1a2"}[chunkId] + ".chunk.css";
};